import React, { Component, } from 'react';
import { withRouter } from 'react-router';
import LoadingOverlay from 'react-loading-overlay';
import logo_img from '../images/Smart.png';
import {Language, Translator, UserController} from '../';
import '../styles/Login.css';
import firebase from '../../Firebase';

class Signin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      username: '',
      password: '',
      logedin: false,
      showFooterMenu: false,
      response: {
        success: false,
        error: null,
        loading: false
      }
    };
  }

  onSubmit = (e) => {
    e.preventDefault();
    const state = this.state;
    state.response.loading= true;
    state.logedin = false;
    this.setState(state);

    //Checkuser Info

    UserController.setData(state.username, state.password).then((res) => {
      if(!res.success){
        state.response.success = false;
        state.response.error= "Invalid login";
        state.logedin = false;
        state.response.loading= false;
        state.username = '';
        state.password = '';
        this.setState(state);
      }
      else{
        state.response.error= null;
        state.response.success = true;
        state.logedin = true;
        state.response.loading= true;
        state.username = '';
        state.password = '';
        this.setState(state);
        window.location.href = `${process.env.PUBLIC_URL}/dashboard/`;
      }
    }).catch((error) => {
        alert(error);
    });
 
  //END Checkuser Info
  }

  onChange = (e) => {
    const state = this.state
    state[e.target.name] = e.target.value;
    this.setState(state);
  }

  render() {
    const {loading, error, success} = this.state.response;
    const { username, password, logedin } = this.state;
    const location = window.location.host;
    return (
      <LoadingOverlay active={loading} spinner text={!logedin ? 'Verifying...' : 'Logging in'}>
        
        <body className = "login-body d-flex flex-column justify-content-center align-items-center" style = {{height: "100%", width: "100%",margin: "0px",padding: "0px",overflow: "scroll",backgroundColor: "#0AACDF"}}>
          <main className="main">
            <div className="container-fluid">
              <div className="logo">
                <img src={logo_img} />
                <h6><b>SMART GROWTH DIARY</b></h6>
                <h6 className='m-0 p-0'>Temeke Municipal Council</h6>
              </div>
              <div className="col-xs-12 col-sm-12 col-md-6 offset-md-3">
                <form onSubmit={this.onSubmit}>
                  <center><h4 style={{color:"red"}}>{error}</h4></center>
                  <div className="form-group">
                    <input required type="text" name="username" value = {username} placeholder="Enter Username" className="form-control" onChange={this.onChange} />
                  </div>
                  <div className="form-group">
                    <input required type="password" name="password" value = {password}  placeholder="Enter Password" className="form-control" onChange={this.onChange} />
                  </div>
                  <div className="form-group">
                    <input type="submit" name="login" value="Login" className="btn form-control" id="loginButton" />
                    <div class="register">
                      {/* <a style={{color: "black", textDecoration: 'none'}}>
                        <button onClick={(event)=>{
                          window.location.href = `https://sgd-parent-reg-app.apps.vannahadvisory.com`;
                          event.preventDefault();
                        }}>Register</button>
                      </a> */}
                    </div>
                        <div class="forgot">
                          <a href={`https://sgd-parent-reg-app.apps.vannahadvisory.com/ForgotPassword`}>Forgot password?</a>
                        </div>
                  </div>
                  {/* <i><FaMugHot/></i> */}
                </form>
              </div>
            </div>
          </main>
          <footer className="footer">
            <h6 style={{fontSize: "0.8em",fontFamily: "Abel"}}>Powered by</h6>
            <h5 style={{fontSize: "1em",fontFamily: "Arimo"}}><b>FABS</b>TECH</h5>
          </footer> 
        </body>

      </LoadingOverlay>
    );
  }
}

export const Login= Signin;
export default withRouter(Signin);